import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class JournalLedgerListItem extends SearchModelBase {
    type: string = '';
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    branch: string = '';
    groupOrder: number = 0;
    seq: number|null = null;
    fromSeq: number|null = null;
    toSeq: number|null = null;
    entity: string = '';
    description: string = '';
    remark: string = '';
    accountNo: string = '';
    accountName: string = '';
    subCode: string = '';
    currency: string = '';
    fDebit: number|null = null;
    fromFDebit: number|null = null;
    toFDebit: number|null = null;
    fCredit: number|null = null;
    fromFCredit: number|null = null;
    toFCredit: number|null = null;
    exRate: number|null = null;
    fromExRate: number|null = null;
    toExRate: number|null = null;
    seqOrder: number = 0;
    debit: number|null = null;
    fromDebit: number|null = null;
    toDebit: number|null = null;
    credit: number|null = null;
    fromCredit: number|null = null;
    toCredit: number|null = null;
    jourType: string = '';
    updateDate: string | null = null;
    fromUpdateDate: string | null = null;
    toUpdateDate: string | null = null;
    updateBy: string = '';
    lineColor: string = '';

    // For journal search
    tbType: number|null = null;
    tbId: number|null = null;
    tbName: string|null = null;
    tbIndex: string|null = null;
    fKey: string|null = null;
    mblId: number|null = null;
    mtbName: string|null = null;
    paymentIds: string|null = null;
    // UI only
    id: number = 0;

    status: string = '';
    sideMenu : string|null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true }),
        XCol.Create({ col: 1, text: 'Type', width: 40, dataIndex: 'type'}),
        XCol.Create({ col: 2, text: 'Date', width: 75, dataIndex: 'postDate',  defaultColumnFocus: true, type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch'}),
        XCol.Create({ col: 4, text: 'Seq', width: 40, dataIndex: 'seq', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 5, text: 'Entity', width: 120, dataIndex: 'entity'}),
        XCol.Create({ col: 6, text: 'Description', width: 150, dataIndex: 'description'}),
        XCol.Create({ col: 7, text: 'Remark', width: 120, dataIndex: 'remark'}),
        XCol.Create({ col: 8, text: 'Account #', width: 80, dataIndex: 'accountNo', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 9, text: 'Account Name', width: 150, dataIndex: 'accountName'}),
        XCol.Create({ col: 10, text: 'Sub Code', width: 80, dataIndex: 'subCode'}),
        XCol.Create({ col: 11, text: 'CUR', width: 40, dataIndex: 'currency'}),
        XCol.Create({ col: 12, text: 'Debit', width: 100, dataIndex: 'fDebit', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 13, text: 'Credit', width: 100, dataIndex: 'fCredit', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 14, text: 'Ex.Rate', width: 60, dataIndex: 'exRate', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.0000', noNullOrEmptySearch: true }),
        XCol.Create({ col: 15, text: 'Debit($$currency)', width: 100, dataIndex: 'debit', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 16, text: 'Credit($$currency)', width: 100, dataIndex: 'credit', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 17, text: 'Journal Type', width: 120, dataIndex: 'jourType'}),
        XCol.Create({ col: 18, text: 'Update Date', width: 100, dataIndex: 'updateDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 19, text: 'Update by', width: 80, dataIndex: 'updateBy'})
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: JournalLedgerListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: JournalLedgerListItem[], sideMenu : string) {
        return data.map((d: JournalLedgerListItem, i) => ({
            ...d,
            id: i + 1, 
            sideMenu : sideMenu,
            //id: d.tbId,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        postDate: {from: 'fromPostdate', to: 'toPostdate'},
        updateDate: {from: 'fromUpdateDate', to: 'toUpdateDate'},
        fDebit: {from: 'fromFDebit', to: 'toFDebit'},
        fCredit: {from: 'fromFCredit', to: 'toFCredit'},
        exRate: {from: 'fromExRate', to: 'toExRate'},
        debit: {from: 'fromDebit', to: 'toDebit'},
        credit: {from: 'fromCredit', to: 'toCredit'},
        seq: {from: 'fromSeq', to: 'toSeq'},
    }
}
